import { Helpers } from '../../helpers';
import { IEquation } from '../../interfaces/iequation';
import { DrillDesign } from '../drill-design';
import { EquationType } from '../equation-type';
import { PhaseStepType } from '../phase-step-type';
import { ResourceCalculation } from '../resource-calculation';
import { ScheduleActivity } from '../schedule-activity';

export class EquationBase {
  EquationId: number;
  EquationValue: string;
  DrillDesignId: number | null;
  EquationTypeId: number;
  VariableName: string | null;
  Description: string | null;
  ExecutionOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  CustomMethod: string | null;
  PhaseStepTypeId: number | null;

  ResourceCalculations_Equation?: Array<ResourceCalculation> | null;
  ScheduleActivities_DurationEquations?: Array<ScheduleActivity> | null;
  DrillDesign?: DrillDesign;
  EquationType?: EquationType;
  PhaseStepType?: PhaseStepType;

  constructor(item?: IEquation) {
    if (item) {

      this.EquationId = item.EquationId;
      this.EquationValue = item.EquationValue;
      this.DrillDesignId = item.DrillDesignId;
      this.EquationTypeId = item.EquationTypeId;
      this.VariableName = item.VariableName;
      this.Description = item.Description;
      this.ExecutionOrder = item.ExecutionOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.CustomMethod = item.CustomMethod;
      this.PhaseStepTypeId = item.PhaseStepTypeId;

      this.ResourceCalculations_Equation = Helpers.createClassArray(ResourceCalculation, item.ResourceCalculations_Equation);
      this.ScheduleActivities_DurationEquations = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_DurationEquations);
      this.DrillDesign = new DrillDesign(item.DrillDesign);
      this.EquationType = new EquationType(item.EquationType);
      this.PhaseStepType = new PhaseStepType(item.PhaseStepType);
    }
  }
}